<template>
  <b-container fluid id="login">
    <b-row class="h-100">
      <b-col align-self="center" md="6">
        <div v-if="0" class="text-center">
          <img class="brand" src="@/assets/img/logo-pedale.png" @click="goHome()">

        </div>
        <b-row align-h="center">
          <b-col lg="8" xl="6">
            <div class="text-center mb-2 mb-md-4">
              <div>
                <h4>Recuperar Senha</h4>
                <p class="text-muted">Esqueceu sua senha? Digite o seu e-mail de cadastro no campo abaixo:</p>
              </div>
            </div>

            <!--===== Form Recover Pass =====-->
            <el-form
              id="recoverPass"
              :model="recoverPassForm"
              status-icon
              :rules="recoverPassFormRules"
              ref="recoverPassForm"
              class="recover-pass-form">

              <el-form-item  label="E-mail" prop="email">
                <el-input
                  @keyup.enter.native="submitRecoverPassForm('recoverPassForm')"
                  v-model.trim="recoverPassForm.email"
                  autocomplete="off"
                  placeholder="Digite seu e-mail">
                  <template v-if="false" slot="prepend">
                    <v-icon name="user"></v-icon>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item class="d-none">
                <el-input
                  hidden
                  >
                </el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                  @click="submitRecoverPassForm('recoverPassForm')"
                  :loading="loading"
                  type="primary"
                  class="mt-3 d-block w-100 font-weight-bold"
                  round>
                  Recuperar Senha
                </el-button>
              </el-form-item>
            </el-form>
            <!--===== End Recover Pass =====-->

            <div class="text-center">
              <router-link to="/login">Voltar ao login</router-link>
            </div>

          </b-col>
        </b-row>
      </b-col>
      <b-col :style="{backgroundImage : `url(${bgLogin})`}" class="bg-cover bg-center bg-primary">
        <router-link to="/" class="← back-to-site">← Voltar ao site</router-link>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
    import bgLogin from '@/assets/img/login.jpg';

    export default {
        name: 'RecoverPass',
        data() {
            return {
                baseUrl: process.env.VUE_APP_BASE_URL,
                apiV1: process.env.VUE_APP_API_V1,
                loading: false,
                bgLogin,
                recoverPass: '',
                recoverPassForm: {
                    email: ''
                },
                recoverPassFormRules: {
                    email: [
                        {required: true, message: 'Por favor, preencha seu e-mail', trigger: 'blur'},
                        {
                            type: 'email',
                            message: 'Por favor, digite um endereço de e-mail válido',
                            trigger: ['blur', 'change']
                        }
                    ]
                },
            };
        },
        methods: {

            submitRecoverPassForm(form) {

                this.$refs[form].validate((valid) => {

                    this.loading = true;

                    if (valid) {
                        this.$store.dispatch('auth/forgotPassword', this.recoverPassForm.email)
                            .then(() => {
                                this.$message({
                                    message: 'As instruções para alterar a senha foram enviadas para seu e-mail.',
                                    type: 'success'
                                });
                                this.loading = false;
                                this.$router.push('/recuperar-senha/token')
                            })
                            .catch(() => {
                                this.loading = false;
                        })
                    }
                    else {
                        this.loading = false;
                        this.$message.error('Preencha os campos corretamente!');
                        return false;
                    }
                });
            },

            goHome() {
                this.$router.push('/');
            }
        },
        computed: {
          loggedIn() {
              return this.$store.state.auth.status.loggedIn;
          },
        },
        created() {
          if (this.loggedIn) {
              this.$router.push('/painel/inicio')
          }
        },
    }
</script>
